import React from 'react';
import { Card, CardContent, Box, Typography, Chip } from '@mui/material';

const formatNumber = (num, decimals = 6) => {
  if (num === null || num === undefined) return '-';
  return Number(num).toLocaleString(undefined, { maximumFractionDigits: decimals });
};

const formatDate = (s) => {
  if (!s) return 'N/A';
  try {
    return new Date(s).toLocaleString();
  } catch {
    return String(s);
  }
};

const assetClassColor = (c) => {
  const v = String(c || '').toLowerCase();
  if (v === 'perp') return 'warning';
  if (v === 'spot') return 'info';
  return 'default';
};

const HyperliquidMarketCard = ({ hit }) => {
  if (!hit) return null;
  const m = hit._source || {};
  return (
    <Card sx={{ mb: 2, backgroundColor: '#fafafa' }}>
      <CardContent sx={{ pb: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
          <Box sx={{ minWidth: 0 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
              {m.normalized_coin || m.raw_coin || m.market_id || 'Unknown market'}
            </Typography>
            <Typography variant="caption" sx={{ color: 'text.secondary', wordBreak: 'break-all' }}>
              {m.market_id}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: 0.75, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
            {m.asset_class && (
              <Chip size="small" label={m.asset_class} color={assetClassColor(m.asset_class)} />
            )}
            {m.coin_namespace && <Chip size="small" label={m.coin_namespace} variant="outlined" />}
            {m.network && <Chip size="small" label={m.network} variant="outlined" />}
          </Box>
        </Box>

        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.5, mt: 1.5 }}>
          <Typography variant="body2" color="text.secondary">Mid Price</Typography>
          <Typography variant="body2" sx={{ textAlign: 'right' }}>{formatNumber(m.all_mids_price)}</Typography>

          <Typography variant="body2" color="text.secondary">Raw Coin</Typography>
          <Typography variant="body2" sx={{ textAlign: 'right' }}>{m.raw_coin || '-'}</Typography>

          <Typography variant="body2" color="text.secondary">Source</Typography>
          <Typography variant="body2" sx={{ textAlign: 'right' }}>{m.metadata_source || '-'}</Typography>

          <Typography variant="body2" color="text.secondary">Updated</Typography>
          <Typography variant="body2" sx={{ textAlign: 'right' }}>{formatDate(m.updated_at)}</Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default HyperliquidMarketCard;
